import React from "react";
import Icon from "../atoms/Icon";

const Navbar = ({ titles }) => {
  // Map the titles to create title components
  const titleComponents = titles.map((title, index) => (
    <div
      key={index}
      className={`flex flex-row items-center gap-2.5 ${
        index !== 0 ? "text-16 font-semibold text-dark-blue-200" : ""
      }`}>
      {index !== 0 && <Icon iconName="arrow-leftD" />}
      <span>{title}</span>
    </div>
  ));

  return (
    <div
      className="sticky top-0 z-1 bg-white h-90 ml-7.5 shadow-md mr-7.5px ml-7.5px flex flex-row justify-between items-center pr-8.5 pl-8.5 rounded-b-sm"
      dir="rtl">
      <div className="text-16 font-semibold text-dark-blue-200 flex flex-row items-center gap-2.5">
        {titleComponents}
      </div>
      <div className="flex flex-row gap-2.5">
        {/* 
          Uncomment the buttons below as needed.
          <button className="w-10 h-10 border-2 border-gray border-solid flex items-center justify-center rounded-full">
            <Icon iconName="moon" />
          </button>
          <button className="w-10 h-10 border-2 border-gray border-solid flex items-center justify-center rounded-full">
            <Icon iconName="notification" />
          </button>
        */}
      </div>
    </div>
  );
};

export default Navbar;
